/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsRevenueOverviewCtrl
 */
angular.module('mercury.modules.reports.revenue')
.controller('ReportsRevenueOverviewCtrl',
  ["Budgets", "$scope", "$q", "reporttime", "ReportItemCategories", "ReportSales", "ReportOrders", "ReportPosStaff", "$stateParams", "$filter", "title", function(Budgets, $scope, $q, reporttime, ReportItemCategories, ReportSales, ReportOrders, ReportPosStaff, $stateParams, $filter, title) {
  title.set('Revenue Overview');

  $scope.loading = $q.all({
    sales: ReportSales.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval()),
    orders: ReportOrders.getByInterval(reporttime.start(), reporttime.end(), reporttime.interval()),
    budgets: Budgets.getAll(reporttime.start(), reporttime.end()),
    itemCategories: ReportItemCategories.getOrders(reporttime.start(), reporttime.end()),
    staffOrders: ReportPosStaff.getOrders(reporttime.start(), reporttime.end())
  });

  $scope.loading.then(function(results) {
    $scope.sales = results.sales;
    $scope.orders = results.orders;
    $scope.budgets = results.budgets;
    $scope.itemCatGraphData = $filter('orderBy')(results.itemCategories, 'label');

    var totalTransactions = $filter('sumof')(results.sales, 'count');
    $scope.averageSale = (totalTransactions !== 0) ? $filter('sumof')(results.sales, 'invoices') / totalTransactions : 0;

    $scope.totalOrders = $filter('sumof')($scope.orders, 'amount');

    angular.forEach(results.staffOrders, function(staff) {
      staff.ordersPercent = ($scope.totalOrders !== 0) ? (staff.amount / $scope.totalOrders) * 100 : 0;
    });
    $scope.staffOrders = results.staffOrders;
  });

  // Column definition for the 'Nett Sales' graph
  $scope.ordersGraphColums = [
    {label: 'Period', type: 'string', key: 'startTime', filter: 'reporttimeformat'},
    {label: 'Orders', type: 'number', key: 'amount', filter: 'currency'}
  ];

  // Column definition for the 'Item Categories' graph
  $scope.itemCatGraphCols = [
    {label: 'Category', type: 'string', key: 'label'},
    {label: 'Orders', type: 'number', key: 'amount', filter: 'currency'}
  ];
}]);
